import { SET_ALERT, REMOVE_ALERT } from './types.js'

export default {
  [SET_ALERT](state, text) {
    state.toastText = text
    state.showToast = true
  },
  [REMOVE_ALERT](state) {
    state.toastText = ''
    state.showToast = false
  },
}
